<template>
  <div>
    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="box-header">
        <span class="box-header__title">Список новостей</span>
        <el-button
          class="box-header__button"
          size="mini"
          @click="addItem"
          type="primary"
        >Добавить новость в очередь</el-button>
      </div>

      <template>
        <el-table :data="tableData" class="table">
          <el-table-column prop="id" label="id" width="40"/>
          <el-table-column prop="title" label="Заголовок">
            <template slot-scope="scope">
              <el-link type="primary" @click="goItem(scope.row.id)">
                {{ scope.row.title }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="admin_email" label="Отправитель"/>
          <el-table-column label="Дата" width="180">
            <template slot-scope="scope">
              <div class="date">
                {{ $root.dateDefault(scope.row.send_at) || '-' }}
                <span class="date__time"><i class="el-icon-time"></i> {{ $root.timeDefault(scope.row.send_at) }}</span>
              </div>
            </template>
          </el-table-column>

        </el-table>
      </template>
      <div class="error-load" v-if="errorLoadCard">
        <p>Ошибка загрузки</p>
        <el-button type="danger" @click="loadLogic">Загрузить еще раз</el-button>
      </div>
    </el-card>

  </div>
</template>

<script>
export default {
  name: 'cpanel.news.history',
  data () {
    return {
      tableData: null,
      loading: false,
      errorLoadCard: false,
      item: {
        title: null,
        description: null
      },
      error: null,
      cardId: null,
      selectItem: false,
      addModal: false,
      editModal: false
    }
  },
  created () {
    this.loading = true
    this.loadLogic()
  },
  components: {},
  methods: {
    loadLogic () {
      this.loading = true

      this.$api.push
        .getList()
        .then((response) => {
          this.tableData = response.data.data
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка загрузки списка',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    goItem (id, edit) {
      this.$router.push({
        name: edit ? 'cpanel.news.edit' : 'cpanel.news.item',
        params: { id }
      })
    },
    addItem () {
      this.$router.push({ name: 'cpanel.news.new' })
    }
  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 1960px;
  margin: 0 auto;

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #aaaeba;
    margin: 5px 0 40px 0;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }
}

.table {
  width: 100%;

  &__btn {
    margin: 5px;
  }
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__title {
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;

    color: #303133;
  }
}

.date {
  font-size: 14px;
  line-height: 16px;
  color: #606266;

  &__time {
    margin-left: 11px;
    color: #8E8E93;
  }
}
</style>
